"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardType = void 0;
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardType;
(function (DocumentCardType) {
    /**
     * Standard DocumentCard.
     */
    DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
    /**
     * Compact layout. Displays the preview beside the details, rather than above.
     */
    DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
})(DocumentCardType || (exports.DocumentCardType = DocumentCardType = {}));
//# sourceMappingURL=DocumentCard.types.js.map